<template>
  <div
    v-if="isBannerActive"
    class="banner appearance-extended"
  >
    <div class="banner__content">
      <div class="avatar">
        <the-icon
          v-if="$props.isCollective"
          art="light"
          name="messages"
        />

        <img
          v-else
          alt="avatar"
          class="avatar__image"
          :src="AlvaDesktopHappy"
        />
      </div>
      <div
        class="text body-2"
        v-html="$props.isCollective ? $t('screen.aide.collective.text') : $t('screen.aide.base.text')"
      />

      <div class="btn">
        <basic-button
          v-if="!$props.isCollective && $props.isButton"
          data-track-as="aide-banner"
          :data-track-text="$props.source"
          hierarchy="secondary"
          :label="$t('screen.aide.base.btn')"
          @click="$emit('click', alvaLink)"
        />

        <basic-link
          v-else
          :data-track-as="$props.isCollective ? 'personal-advice-corporate' : 'aide-banner'"
          :data-track-text="$props.source"
          hierarchy="secondary"
          :href="alvaLink"
          :label="$props.isCollective ? $t('screen.aide.collective.btn') : $t('screen.aide.base.btn')"
        >
          <template #trailing>
            <the-icon
              art="solid"
              name="arrow-right-long"
            />
          </template>
        </basic-link>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  import basketStore from '@shared/store/basket'
  import useI18n from '@shared/hooks/useI18n'

  import { BasicButton, BasicLink } from '@shared/components/Basic'

  import { APP } from '@shared/config/constants'
  import AlvaDesktopHappy from '@shared/assets/alva/Alva_Desktop_froehlich_00.06.svg'

  // HOOKS
  const { selectedLanguage, t } = useI18n()

  // INIT
  defineEmits(['click'])
  const props = defineProps({
    isButton: {
      type: Boolean,
      default: false,
    },

    isCollective: {
      type: Boolean,
      default: false,
    },

    source: {
      type: String,
      required: true,
    },

    collectiveHelpLinkDe: {
      type: String,
      default: null,
    },

    collectiveHelpLinkEn: {
      type: String,
      default: null,
    },

    collectiveHelpLinkIt: {
      type: String,
      default: null,
    },

    collectiveHelpLinkFr: {
      type: String,
      default: null,
    },
  })

  // COMPUTED
  const alvaLink = computed(() => {
    if (props.isCollective) {
      // get the value from the correct prop, based on selected Language
      const key = 'collectiveHelpLink' + selectedLanguage.value[0].toUpperCase() + selectedLanguage.value[1].toLowerCase()
      return props[key] ?? t('screen.aide.collective.link')
    } else {
      return APP.AIDE.env + '/' + selectedLanguage.value.toLowerCase()
    }
  })

  const isBannerActive = computed(() => {
    return !basketStore.basket.existingCustomer
  })
</script>

<style scoped>
.banner {
  width: 100%;
}
.banner__content {
  display: grid;
  grid-template-areas:
    'avatar text'
    'button button';
  padding: var(--fixed-spacing-fix-04) var(--fixed-spacing-fix-06);
  row-gap: var(--fixed-spacing-fix-01);
  column-gap: var(--fixed-spacing-fix-04);

  border-radius: var(--radius-border-radius-03);
  background: var(--surface-ext-b-medium);

  .avatar {
    grid-area: avatar;

    .icon {
      font-size: 52px;
    }

    .avatar__image {
      height: 70px;
    }
  }

  .text {
    grid-area: text;
  }

  .btn {
    grid-area: button;
    text-align: right;
  }
}

@media (--v-large) {
  .banner__content {
    grid-template-columns: min-content auto auto;
    grid-template-areas: 'avatar text button';

    .text,
    .btn {
      align-self: center;
    }
  }
}
</style>
